import axios from '../../localAxios';
import { workspaceFoldersURL } from '../workspacesURLs';

export interface DeleteWorkspaceFolderParams {
  workspaceId: string;
  workspaceFolderIds: string[];
}

export type DeleteWorkspaceFolderResponse = { message: string };

export async function deleteWorkspaceFolders({
  workspaceId,
  workspaceFolderIds,
}: DeleteWorkspaceFolderParams) {
  const url = workspaceFoldersURL({ workspaceId });
  const result = await axios.delete<DeleteWorkspaceFolderResponse>(url.href, {
    data: { workspace_folder_ids: workspaceFolderIds },
  });
  return result.data;
}
